import { IGetEntregaObraClienteArquivoAuxByIdUseCase } from "../../../presentation/useCases/read/get_entrega_obra_cliente_arquivo_aux_by_id_use_case";
import { EntregaObraClienteArquivoAuxModel } from "../../models/entrega_obra_cliente_arquivo_aux";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaObraClienteArquivoAuxByIdUseCase
 */

export class GetEntregaObraClienteArquivoAuxByIdUseCase implements IGetEntregaObraClienteArquivoAuxByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraClienteArquivoAux: number): Promise<EntregaObraClienteArquivoAuxModel> {
    return await this.repository.getEntregaObrasClienteArquivosAux(idEntregaObraClienteArquivoAux);
  }

}
